import { render, staticRenderFns } from "./MessageTemplates.vue?vue&type=template&id=001c754c"
import script from "./MessageTemplates.vue?vue&type=script&lang=js"
export * from "./MessageTemplates.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplates.vue?vue&type=style&index=0&id=001c754c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports